require("./brokerCryptoModalDocumentationBody.scss");
import PropTypes from 'prop-types';

const CryptoModalDocumentationBody = ({ children }) => (
    <div className="modal_documentation_body">{children}</div>
);

CryptoModalDocumentationBody.propTypes = {
    children: PropTypes.node.isRequired,
};

export { CryptoModalDocumentationBody };